<template>
  <v-dialog v-model="auctionId" :lazy="true" :persistent="true" max-width="500px">
    <div style="position: relative; background-color: #fff; text-align: center;">
      <v-icon style="cursor: pointer; position: absolute; right: 0; top: 0; padding: 0.5rem;" @click.stop="close">close</v-icon>
      <div style="padding: 0;">
        <div style="text-align: center; padding: 1rem 1.5rem; font-size: 1.4rem; font-weight: 400;">Current Bids</div>
        <v-list subheader two-line>
          <template v-for="bid in orderBy(bids, 'id', -1)">
            <div :key="bid.id">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <img :src="bid.photoUrl"/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ bid.amount | prettyMoney }} <small>by {{ bid.alias }}</small></v-list-tile-title>
                  <v-list-tile-sub-title>{{ bid.created | prettyDateTime }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
            </div>
          </template>

          <div v-if="bids.length === 0">
            <InlineSpinner v-if="loading" />
            <span v-else>No bids</span>
          </div>
        </v-list>
      </div>

    </div>
  </v-dialog>
</template>

<script>
  import InlineSpinner from './elements/InlineSpinner.vue'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'AutoBids',
    components: {
      InlineSpinner
    },
    data() {
      return {
        auctionId: 0,
        loading: false,
        bids: []
      }
    },
    computed: {
      ...mapGetters([
        'subdomain',
        'bidsDialog'
      ])
    },
    watch: {
      bidsDialog(value) {
        this.auctionId = value
        if (this.auctionId > 0) {
          this.fetchBids()
        }
      }
    },
    mounted() {
      // subscribe to auction events
      this.$events.on('auction', auction => {
        if (auction.id === this.auctionId) {
          this.fetchBids()
        }
      })
    },
    methods: {

      ...mapMutations([
        'closeBidsDialog'
      ]),

      close() {
        this.closeBidsDialog()
      },

      fetchBids() {
        if (!this.auctionId) return
        this.loading = true
        this.bids = []
        this.$PfxBackendApi.getBidsForAuction(this.subdomain, this.auctionId).then(res => {
          const bids = res.data || []

          const uniqueBidders = []
          bids.forEach(bid => {
            bid.photoUrl = require('../assets/placeholder-user.png')
            bid.alias = '...'

            const uid = bid.userId
            if (uniqueBidders.indexOf(uid) === -1) {
              uniqueBidders.push(uid)
              this.resolveAvatarForUser(bid, bids)
            }
          })

          this.bids = bids
        }).catch(err => {
          console.log('getBidsForAuction err', err)
          if (err.status !== 404) {
            this.$notify({ type: 'danger', message: 'Cannot fetch data about bids' })
          }
        }).then(() => this.loading = false)
      },

      resolveAvatarForUser(bid, bids) {
        console.log('resolveAvatarForUser for [%s]', bid.userId)
        this.$PfxBackendApi.getUser(bid.userId).then(res => {
          // loop and the same data for all user with same userId
          bids.forEach(bid => {
            if (bid.userId === res.data.id) {
              if (res.data.photoUrl) {
                bid.photoUrl = res.data.photoUrl
              }
              bid.alias = res.data.alias || res.data.id
            }
          })
        }).catch(err => {
          console.warn('getUser (bid user) err', err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AuctionBids.vue